// extracted by mini-css-extract-plugin
export default {"wrap":"SidebarLayout_wrap__x9gFw","sidebar":"SidebarLayout_sidebar__pdNi6","sidebar-content":"SidebarLayout_sidebar-content__ErdUW","content":"SidebarLayout_content__LhxIp"};